// extracted by mini-css-extract-plugin
module.exports = {"container":"_2D24r3QGI2OugwMx2mceGz","deleteBtnWrapper":"uK2YDbJydBo9mv-zMT60q","deleteBtn":"_1hBX1Ffv99ZjtJpHDLhkv3","icon":"f-kr7gB9kEFdM3ykZd_Sm"};